class ArtikelTeilen extends HTMLElement {
    connectedCallback() {
        const shareButton = this.createButton();
        this.appendChild(shareButton);

        this.artikelTeilenButton = shareButton;
        if (this.artikelTeilenButton === null) return;
        this.artikelTeilenButton.addEventListener('click', () => {
            this.linkTeilen();
        })
    }

    createButton() {
        const shareButton = document.createElement("button");
        shareButton.className = "element-button-secondary-small-icon";
        shareButton.type = "submit";
        shareButton.setAttribute("interaction", "artikel-teilen");
        shareButton.innerText = "Artikel teilen";

        const buttonIcon = document.createElement("span");
        buttonIcon.className = "element-icon-social-teilen";

        shareButton.appendChild(buttonIcon);
        return shareButton;
    }

    async linkTeilen() {
        try {
            if (navigator.share) {
                await this.teilenMitShareAPI();
            } else {
                
                try {
                    await this.linkInZwischenablage();
                } catch (error) {
                    console.error(error)
                } finally {
                    this.erzeugeHinweis();
                }

            }
        } catch (error) {
            console.error(error);
        }
    }

    erzeugeHinweis() {
        const html = `<div class="element-snackbar-success element-text-standard" interaction="erzeugter-hinweis" data-animation="slidein-bottom">Der Link wurde in die Zwischenablage kopiert.</div>`;
        this.insertAdjacentHTML("beforeend", html);
        const currentElement = this.querySelector("[interaction=erzeugter-hinweis]");
        currentElement.setAttribute("animate", "");
        setTimeout(() => {
            const element = this.querySelector("[interaction=erzeugter-hinweis]");
            element.remove();
        }, 5000);
    }

    async teilenMitShareAPI() {
        const locationHostname = this.getLocationHostnameWithoutWWW();
        const title = `Mein Artikel auf ${locationHostname}`;
        const text = `Schau mal hier, mein Artikel auf ${locationHostname}`;
        try {
            const sharedata = {
                title: title,
                text: text,
                url: this.getShareUrl().toString()
            }
            await navigator.share(sharedata);
        } catch (error) {
            console.info(error);
        }
    }

    async linkInZwischenablage() {
        const url = this.getShareUrl().toString();
        await navigator.clipboard.writeText(url)
    }

    getShareUrl() {
        const url = new URL(window.location.href);
        return url;
    }

    getLocationHostnameWithoutWWW() {
        const hostname = window.location.hostname;
        const hasWWW = hostname.indexOf("www") !== -1;
        if (hasWWW) {
            return hostname.replace("www.", "");
        }
        return hostname;
    }

}

if (!customElements.get("artikel-teilen")) {
    customElements.define("artikel-teilen", ArtikelTeilen);
}
